import { filter } from 'rxjs';

import { OnInit, signal, Component, WritableSignal } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd, ActivatedRoute } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';
import { ErrorStateService } from '@/app/core/services/error-state.service';

import { ButtonComponent } from '@/app/shared/components/ui/button';
import { LoadingIndicatorComponent } from '@/app/shared/components/ui/loading-indicator';
import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon/svg-icon.component';
import { SidebarComponent } from '@/app/shared/components/layout/sidebar/sidebar.component';

import { UserInterface } from '@/app/shared/interfaces/user.interface';

@Component({
  selector: 'app-admin-default-layout',
  templateUrl: './admin-default-layout.component.html',
  styleUrl: './admin-default-layout.component.scss',
  imports: [RouterOutlet, SidebarComponent, ButtonComponent, SvgIconComponent, LoadingIndicatorComponent],
})
export class AdminDefaultLayoutComponent implements OnInit {
  protected user: WritableSignal<UserInterface | undefined> = signal(undefined);

  constructor(
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected authService: AuthService,
    protected readonly errorStateService: ErrorStateService,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.errorStateService.clearErrorMessage();
    });

    const deepest = this.getDeepestChild(this.activatedRoute);
    deepest.data.subscribe((data) => {
      if (data['userResponse']) {
        this.user.set(data['userResponse'].payload.content);
      }
    });
  }

  protected openUsersPage() {
    this.router.navigate(['/admin/users']);
  }

  protected getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
